"use client";

import {useState} from "react";

const Rakuten = () => {
    const [loaded, setLoaded] = useState(false);

    if (loaded === false && typeof window !== 'undefined') {
        (function (url) {
            /*Tracking Bootstrap Set Up DataLayer objects/properties here*/
            if (!window.DataLayer) {
                window.DataLayer = {};
            }
            if (!DataLayer.events) {
                DataLayer.events = {};
            }
            DataLayer.events.SPIVersion = DataLayer.events.SPIVersion || "3.4.1";
            DataLayer.events.SiteSection = "1";

            let loc, ct = document.createElement("script");
            ct.type = "text/javascript";
            ct.async = true; ct.src = url; loc = document.getElementsByTagName('script')[0];
            loc.parentNode.insertBefore(ct, loc);
        }(document.location.protocol + "//tag.rmp.rakuten.com/124376.ct.js"));
        setLoaded(true);
    }
};

export default Rakuten;